import * as Sentry from '@sentry/react';
import { useTranslation } from 'react-i18next';

import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { orderState } from '../../../state/recoilState';
import { BasicScreenProps } from '../../../types';
import { trackPageView } from '../../../utils/tracking';
import { Button } from '../../common/Button';
import ContentBox from '../../common/ContentBox';
import PrimaryButton from '../../common/PrimaryButton';
import SVGObject from '../../common/SVGObject';
import ScreenTitle from '../../common/ScreenTitle';
import ScreenWrapper from '../../common/ScreenWrapper';
import { Box, SvgIcon } from '@mui/material';

interface ErrorScreenProps {
    // onRepeatPurchase: () => void;
    title?: string;
}

const Error404Screen = (props: ErrorScreenProps) => {
    const { title } = props;
    const { t } = useTranslation();
    const order = useRecoilValue(orderState);

    useEffect(() => {
        trackPageView(title || 'Error 404', {
            url: window.location.href,
            orderId: order.id,
            ...order,
        });
        Sentry.captureMessage('Error 404. URL:' + window.location.href);
    }, []);

    function Shrek() {
        return (
            <SvgIcon sx={{ fontSize: '15rem' }}>
                <svg
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="356.000000pt"
                    height="142.000000pt"
                    viewBox="0 0 356.000000 142.000000"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <g
                        transform="translate(0.000000,142.000000) scale(0.100000,-0.100000)"
                        fill="#fc9003"
                        stroke="none"
                    >
                        <path
                            d="M560 1280 c-64 -11 -111 -33 -153 -70 -41 -36 -348 -488 -381 -560
-28 -63 -28 -171 0 -225 23 -45 69 -80 123 -95 20 -5 125 -10 233 -10 l197 0
5 -32 c3 -18 8 -54 11 -80 12 -96 71 -148 174 -156 151 -10 215 49 236 220 6
43 9 47 38 54 83 17 116 68 102 155 -9 54 -37 85 -89 98 l-44 11 -4 287 c-3
250 -5 292 -20 320 -25 45 -63 71 -111 77 -84 11 -273 14 -317 6z m25 -516
l-7 -184 -119 0 c-65 0 -119 2 -119 5 0 5 106 177 196 316 27 42 49 68 52 60
2 -7 1 -96 -3 -197z"
                        />
                        <path
                            d="M2970 1280 c-113 -20 -154 -55 -281 -241 -248 -361 -290 -443 -274
-542 10 -64 50 -124 98 -150 39 -21 56 -22 265 -25 l222 -3 0 -48 c0 -147 70
-221 209 -221 127 1 190 64 206 207 l7 61 44 11 c25 6 53 20 64 31 23 23 34
78 25 127 -7 41 -54 93 -83 93 -54 0 -52 -8 -52 279 0 160 -4 282 -11 306 -14
51 -53 93 -99 104 -51 13 -287 21 -340 11z m25 -627 l-7 -73 -119 0 c-65 0
-119 2 -119 5 0 4 138 224 216 345 l29 45 3 -125 c2 -69 0 -158 -3 -197z"
                        />
                        <path
                            d="M1592 1008 c-17 -17 -15 -53 3 -68 12 -10 21 -10 40 -2 40 19 29 82
-15 82 -9 0 -21 -5 -28 -12z"
                        />
                        <path
                            d="M1920 1006 c-28 -35 11 -93 48 -70 35 22 22 84 -18 84 -10 0 -23 -7
-30 -14z"
                        />
                        <path
                            d="M1754 822 c-40 -26 -45 -102 -9 -137 31 -31 49 -31 80 0 49 48 22
145 -40 145 -11 0 -25 -4 -31 -8z"
                        />
                    </g>
                </svg>
            </SvgIcon>
        );
    }

    return (
        <ScreenWrapper>
            <ScreenTitle>{t('Something goes wrong...')}</ScreenTitle>
            <Box sx={{ display: 'flex' }}>
                {/* <SVGObject
                    src="/src/components/screens/Error404Screen/kek.svg"
                    style={
                        {
                            // marginTop: "-2vmax",
                            // height: '230px',
                            // width: '100vw',
                        }
                    }
                /> */}
                <Shrek />

                {/* <Button onClick={onRepeatPurchase}>
                    {t('Repeat_purchase')}
                </Button> */}
            </Box>
        </ScreenWrapper>
    );
};

export default Error404Screen;
